import React, {useState ,useEffect, FormEvent} from 'react';
import {Link} from "react-router-dom";
import {_printNumber} from '../../helpers/helpers.js'
import {BiggestIP,IPLookupPageResult} from '../../../../server/routes/ip-lookup.js';

//import validateParameterIPAddressAPI from '../../../../server/src/validation.js';

// Define interfaces for the IP data structure

interface IPLookupProps {
    server: string;
    pageData: unknown;
}


export default function IPLookup({server, pageData}: IPLookupProps) {

    const typedPageData = pageData as IPLookupPageResult
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <IPLookupHeader props={data}/>        
            <IPBody props={data}/>
        </>
	)
}


interface IPLookupHeaderProps {
    props: IPLookupPageResult;
}

function IPLookupHeader({props}: IPLookupHeaderProps) {
    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        const q = document.getElementById('q') as HTMLInputElement;
        let t = String(q.value).trim();

//		try {
//			validateParameterIPAddressAPI(t);
			document.location = '/ip/'+t;    
//		} catch (err) {

//		}
        
    }  

    return (
        <section className="section section-sm text-center">
            <div className="container">
                <div className="text-center">
                    <h2>Reverse IP</h2>
                    <p>
                        <span style={{maxWidth: '690px'}}>
						Enter an IP address into our Reverse IP tool, and we'll provide you with a list of all the domains we've detected as being hosted there.
                        </span>
                    </p>
                </div>

                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET"  onSubmit={handleSubmit} >
                        <div className="form-wrap">
                            <input required type="text" className="form-input" title="Reverse IP" placeholder="Enter IPv4 or IPv6 (for example 127.0.0.1)" name="q" id="q"/>
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit" >Search</button>
                        </div>
                    </form>
                </div>            
            </div>
        </section>
    )
}


interface IPBodyProps {
    props: IPLookupPageResult;
}

function IPBody({props}: IPBodyProps) {
    if (!props.BiggestIPs) return (<></>);
	return (
        <>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <IPList title='Top shared IP addresses ordered by hosted domain count' list={props.BiggestIPs}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
	)
};


interface IPListProps {
    title: string;
    list: BiggestIP[];
}

function IPList({title, list}: IPListProps) {
return (
<>
        <h4>{title}</h4>    
        <br/>    
        <div className="table-outer table-rounded table-responsive-lg">
        <table className="table-custom table-custom-striped table-custom-primary  ">
                <thead>
                <tr>
                        <th style={{width: '15%'}}>IP</th>                        
                        <th style={{width: '10%'}}>ASN</th>
                        <th style={{width: '25%'}}>ASN Name</th> 
                        <th style={{width: '30%'}}>Top ranking Domain</th>
                        <th style={{width: '10%'}}>Domain Count</th>
                </tr>
                </thead>
                        <tbody>
                        {
                                list.map((ip, indexKey) => {
                                        return (
                                                <IPRow ip={ip} key={indexKey}/>
                                        )
                                })
                        }	
                </tbody>
        </table>
        </div>
        
</>
)
}

interface IPRowProps {
    ip: BiggestIP;
    requireAuthentication?: boolean;
}

function IPRow({ip, requireAuthentication}: IPRowProps) {
    if (!ip) return (<></>);

return (
        <>
        <tr>         
            <td>                
                <Link 
                    to={`/ip/${ip.IP}`} 
                    className="link-hover" 
                >
                <b>{ip.IP}</b>
                </Link> 
            </td>
            <td>                
                <Link 
                    to={`/asn/${ip.ASNId}`} 
                    className="link-hover" 
                >
                    <b>{ip.ASNId} </b>
                </Link> 	
            </td>       
            <td>	                     
                {ip.ASNName}							
            </td>
            <td>                
                <Link 
                    to={`/website/${ip.HighestRankDomain}`} 
                    className="link-hover" 
                >
                    <b>{ip.HighestRankDomain}</b>
                </Link> 
            </td>
            <td>               
                <Link 
                    to={`/asn/${ip.ASNId}/websites`} 
                    className="link-hover" 
                >
                    <b>{_printNumber(ip.DomainCount)}</b>
                </Link> 
            </td>
        </tr>		
        </>
)
}
